import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import S from './Trigger.styled'
import { useDropdownContext } from '../DropdownContext'

const Trigger = ({
  children,
  isActiveFilter = false,
  isTitleOnMobile = false,
  accentColor,
}) => {
  const { isMobile, isOpen, toggle, onBlur, themeColor, dropdownContentId } = useDropdownContext()

  useEffect(() => {
    if (
      !isMobile &&
      document.body.classList.contains('dropdown-mobile-menu-open')
    ) {
      document.body.classList.remove('dropdown-mobile-menu-open')
    }

    if (isMobile) {
      if (isOpen) {
        if (!document.body.classList.contains('dropdown-mobile-menu-open')) {
          document.body.classList.add('dropdown-mobile-menu-open')
        }
      } else if (document.querySelector('.dropdown-menu-content')) {
        if (!document.body.classList.contains('dropdown-mobile-menu-open')) {
          document.body.classList.add('dropdown-mobile-menu-open')
        }
      } else {
        if (document.body.classList.contains('dropdown-mobile-menu-open')) {
          document.body.classList.remove('dropdown-mobile-menu-open')
        }
      }
    }
  }, [isMobile, isOpen])

  const onTriggerClick = () => {
    if (isMobile) {
      document.body.classList.add('dropdown-mobile-menu-open')
    }

    toggle()
  }

  const onKeyDown = (e) => {
    if (e?.key === 'Enter') {
      e.preventDefault()
      
      if (isMobile) {
        document.body.classList.add('dropdown-mobile-menu-open')
      }

      toggle()
    }
  }

  return (
    <S.Trigger
      tabIndex="0"
      className="dropdown-trigger"
      onKeyDown={onKeyDown}
      onMouseDown={(e) => e.preventDefault()}
      isOpen={isOpen}
      aria-controls={dropdownContentId}
      aria-expanded={isOpen}
      aria-haspopup="true"
      onClick={onTriggerClick}
      onBlur={onBlur}
      isActiveFilter={isActiveFilter}
      isTitleOnMobile={isTitleOnMobile}
      accentColor={accentColor}
      themeColor={themeColor}
    >
      {children}
    </S.Trigger>
  )
}

Trigger.propTypes = {
  children: PropTypes.node.isRequired,
  isActiveFilter: PropTypes.bool,
  isTitleOnMobile: PropTypes.bool,
  accentColor: PropTypes.string,
}

export default Trigger
